import React, { useEffect } from 'react';
// @mui
import { Card, Stack } from '@mui/material';
// redux
import { useDispatch, useSelector } from 'src/redux/store';
import { getReportRows } from 'src/redux/slices/report';
// utils
import { uniqueEntry } from 'src/utils/array-utils';
// components
import ReportToolbar from 'src/components/report/report-toolbar';
import { ReportTableSkeleton } from 'src/components/report/report-table-skeleton';
import ReportDetailsTableElement from './report-details-table-element';

export default function ReportDetailsBuilder() {
  const dispatch = useDispatch();

  const rows = useSelector((state) => state.report.rows);
  const intervalRows = useSelector((state) => state.report.intervalRows);
  const report = useSelector((state) => state.report.report);
  const loading = useSelector((state) => state.report.loading);
  const filter = useSelector((state) => state.report.filter);
  const error = useSelector((state) => state.errorMessage.currentError);

  useEffect(() => {
    if (
      filter.dataSource &&
      filter.dataSource.length > 0 &&
      !error &&
      filter.fromDate !== null &&
      filter.toDate !== null
    ) {
      dispatch(
        getReportRows({
          fromDate: filter.fromDate,
          toDate: filter.toDate,
          dataSource: filter.dataSource,
          templateId: null,
        })
      );
    }
  }, [dispatch, filter, error]);

  return (
    <Stack spacing={3}>
      <Card>
        <ReportToolbar disableEdit />
      </Card>
      {report.tables &&
        report.tables.map((x, i) =>
          x.intervalModel && x.intervalModel.length > 0
            ? x.intervalModel.map(
                (interval) =>
                  x.columns && (
                    <ReportDetailsTableElement
                      rows={rows}
                      columns={x.columns}
                      table={x as any}
                      index={i}
                      key={`${i}-${interval}`}
                      interval={interval}
                      filterItems={x.filterModel}
                    />
                  )
              )
            : x.columns && (
                <ReportDetailsTableElement
                  rows={rows}
                  columns={x.columns}
                  table={x as any}
                  index={i}
                  key={i}
                  filterItems={x.filterModel}
                />
              )
        )}
      {(!report.tables || report.tables.length === 0) && loading[0] && <ReportTableSkeleton />}
    </Stack>
  );
}
